// src/main.js
import * as Sentry from "@sentry/vue";
import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import './assets/tailwind.css';
import './firebase';
import ar from './locales/ar.json';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import hi from './locales/hi.json';
import sw from './locales/sw.json';
import zh from './locales/zh.json';
import FontAwesomeIcon from './plugins/font-awesome';
import './registerServiceWorker';
import router from './router';
import store from './store';

const app = createApp(App);

// Initialize Sentry
Sentry.init({
    app,
    dsn: "https://e887cac1e3f1aec499e647d30e7c12e1@o4509950149132288.ingest.us.sentry.io/4509950156013568",
    integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
});

const messages = {
    en, sw, de, ar, zh, fr, es, hi,
};

const i18n = createI18n({
    locale: 'en', // default locale
    legacy: false, // Enables Composition API mode
    globalInjection: true, // Allows global use of $t and other i18n methods
    fallbackLocale: 'en',
    messages,
});

app.component('font-awesome-icon', FontAwesomeIcon);

app
    .use(router)
    .use(store)
    .use(i18n)
    .mount('#app');
